import _ from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { Badge, SideNavigation } from "@toddle-edu/ds-web";
import { useTranslation } from "react-i18next";

const SideBarNavigation = props => {
  const {
    filteredNodes,
    onChangeOutline,
    selectedNodeId,
    shouldShowSideNavWithoutTitle,
  } = props;
  const { t } = useTranslation(["journal"]);

  const styles = {
    sidebarContainer: {
      maxWidth: "246px",
      height: "100%",
    },
  };
  const [id, setId] = useState(selectedNodeId);
  useEffect(() => {
    setId(selectedNodeId);
  }, [selectedNodeId]);

  const sideBarOptions = useMemo(() => {
    const options = [];
    _.map(filteredNodes, item =>
      options.push({
        key: item.id,
        title: item.label,
        tier: 1,
        parent: "node_selection",
        children: [],
        ...(item.count
          ? {
              suffix: <Badge variant="filter" value={item.count}></Badge>,
            }
          : {}),
      })
    );
    return [
      {
        key: "root",
        children: shouldShowSideNavWithoutTitle
          ? [..._.map(options, option => _.get(option, "key", undefined))]
          : ["node_selection"],
        tier: 2,
      },

      {
        key: "node_selection",
        children: [
          ..._.map(options, option => _.get(option, "key", undefined)),
        ],
        tier: 2,
        title: shouldShowSideNavWithoutTitle
          ? ""
          : t("common:outline").toUpperCase(),
        parent: "root",
      },
      ...options,
    ];
  }, [filteredNodes]);

  return (
    <div>
      <SideNavigation
        options={sideBarOptions}
        onClick={e => {
          setId(e);
          onChangeOutline({ selectedNodeId: e, forcePosition: true });
        }}
        containerStyle={styles.sidebarContainer}
        selectedOptionKey={id}
        rootKey={"root"}
      />
    </div>
  );
};

export default SideBarNavigation;
